/**
=========================================================
* Renix redesign — MuiChip override (new, dark)
=========================================================
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { borderColor } = colors;
const { borderRadius } = borders;
const { size, fontWeightRegular } = typography;

const chip = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.sm,
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      height: pxToRem(24),
    },
    outlined: {
      borderColor: borderColor.main,
    },
    label: {
      paddingLeft: pxToRem(8),
      paddingRight: pxToRem(8),
    },
  },
};

export default chip;
